import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import HomePage from './pages/HomePage';
import WordPage from './pages/WordPage';
import WritingTipsPage from './pages/WritingTipsPage';
import DictionaryPage from './pages/DictionaryPage';
import TranslationsPage from './pages/TranslationsPage';
import WordOfTheDayPage from './pages/WordOfTheDayPage';
import NotFoundPage from './pages/NotFoundPage';
import Layout from './components/Layout';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Disclaimer from './pages/Disclaimer';
import ContactUs from './pages/ContactUs';
import './App.css';

// Old /dictionary/:word links keep working
const LegacyWordRedirect = () => {
  const { word } = useParams();
  return <Navigate to={`/define/${encodeURIComponent(word)}`} replace />;
};

// Frontend-only dictionary application
// No backend dependencies - everything runs client-side
function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/"                   element={<HomePage />} />
            <Route path="/dictionary"         element={<DictionaryPage />} />
            <Route path="/define/:word"       element={<WordPage />} />
            <Route path="/word-of-the-day"    element={<WordOfTheDayPage />} />
            <Route path="/translations"       element={<TranslationsPage />} />
            <Route path="/writing-tips"       element={<WritingTipsPage />} />
            {/* /blog and /blog/tech-explained are the WordPress site served by Hostinger from public_html/blog */}

            <Route path="/about"              element={<AboutUs />} />
            <Route path="/privacy-policy"     element={<PrivacyPolicy />} />
            <Route path="/disclaimer"         element={<Disclaimer />} />
            <Route path="/contact"            element={<ContactUs />} />

            {/* Old URLs */}
            <Route path="/dictionary-search"  element={<Navigate to="/dictionary" replace />} />
            <Route path="/dictionary/:word"   element={<LegacyWordRedirect />} />

            <Route path="*"                   element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
